import React, { useEffect, useMemo, useState } from "react";
import * as image from "../../resources/images";
import { Line } from "rc-progress";
import { getSequnceSort } from "../../utils/helper";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { PATHS } from "../../utils";
import { lockPopup, setProviderModal } from "../../redux/actions";
import { useDispatch } from "react-redux";
const CourseAbout = ({ courseData, refrence, showProgress, loginType, handlePlanGoals, currentCourse}) => {
	const history = useHistory();
	const params = useParams();
	const dispatch = useDispatch();
	const handleContinue = (courseObj, module) => {
		// console.log("handleContinue : ", params, module);
		if (params?.activityId !== module?.id) {
			// window.location.href = PATHS.STR_COURSE_DETAIL + "/" + courseObj?.id + "/" + module?.id;

			 history.push({
						pathname: PATHS.STR_COURSE_DETAIL + "/" + courseObj?.id + "/" + module?.id,
						state: { course: currentCourse }
					})

			window.location.reload();
		}
	}

	const setProviderPopup = (provider, data) => {
			provider.courseObj = data;
			dispatch(setProviderModal(provider));
		};

	const showLockPopUp = (courseObj) => {
			dispatch(lockPopup({ isLocked: true, courseObj: currentCourse }));
		};
	// console.log("currentCourse : ", courseData, getSequnceSort(courseData?.activities));
	return (
		<>
			<div className="coursedetails mt-4 pt-3 mb-3 px-3 br-17 border4">
				<div className="flexone mb-3 flex-wrap">
					<div className="About_course_name mr-3 pr-3">
						<h3>About The Course</h3>
					</div>
					<div className="About_course_name pointer mr-auto ml-3 pl-3" onClick={()=>handlePlanGoals()}>
                        {/* <h3>Edit</h3> */}
						{!currentCourse?.isComic && (
							<sapn className="enroll_link"><i class="fa-solid fa-pen mr-1"></i>
								{!currentCourse?.isDefinedGoal && !currentCourse?.isCompleted ? "Set Goals" : "Edit Goals"}
							</sapn>
						)}
						
                    </div>
					
					<div className={`providerconut flextwo ${courseData?.providers?.length > 2 ? " mt-3":""}`}>
					{   courseData?.providers?.map((provider, key) => (
						
						
						<div 
							onClick={() =>
										setProviderPopup(provider, courseData)
									}
							className={`flextwo  ${courseData?.providers?.length > 2 ? "mr-3":"mr-3"} pointer`} key={key}>
							<div className="items_image mr-3">
								<img
									src={provider.imageUrl}
									alt="character_image"
									className="br-50 "
								/>
							</div>
							<div className="aboutitemsdtl">
								<h4>{provider?.name}</h4>
							</div>
						</div>
						
					))}
                  </div>
				</div>
				<div>
					<div className={`${currentCourse?.dimesnion?.name}DimCard course_progress`}>
						<div className="w-40">
							<p className="p3 textuppercase">
								<span className="mr-1">{loginType ? showProgress : 0}%</span> progress{" "}
								{/* <span className="ml-1">🎉</span> */}
								<span className="ml-1">
									{loginType && showProgress >= 25 && showProgress < 50 ? '🎉' : ''}
									{loginType && showProgress >= 50 && showProgress < 75 ? '🤩' : ''}
									{loginType && showProgress >= 75 && showProgress < 100 ? '🥳' : ''}
									{loginType && showProgress >= 100 ? '🎊🥳🤩🎉' : ''}
								</span>
							</p>
							<Line percent={loginType ? showProgress : 0} strokeWidth={10} strokeColor="#FF9900" />
						</div>
						<p className="p2 light_paragraptxt ">
							{courseData?.description}{" "}
						</p>
					</div>
					<div className="modulelist mt-3 pt-2">
						{
							getSequnceSort(courseData?.activities)?.map((module, index) => {
								return useMemo(()=>(
									<div className={`modulelistitem mb-3 ${loginType && module?.isLocked ? "locked_modules" : ""}`} key={module?.id}>
									
									<h4>
										{loginType && module?.isLocked ? (
											<span key={Math.random()} className="">
												<i class="fa-solid fa-lock-keyhole mr-2"></i>
											</span>
										) : (
											<span key={Math.random()} className="play_icon">
												<i class="fa-solid fa-circle-play mr-2"></i>
											</span>
										)}
										{
											loginType && module?.isLocked ? (
												<a href="javascript:void(0)" onClick={() => showLockPopUp(courseData)}>Module {index + 1}: {module?.name}</a>
											) : (
												<a href="javascript:void(0)" onClick={() => handleContinue(courseData, module)}>Module {index + 1}: {module?.name}</a>
											)
										}
									</h4>
									<p className="p2 light_paragraptxt"
										dangerouslySetInnerHTML={{
										__html: module?.description && module?.description,
										}}
									>
										{/* {module?.description}
										{" "} */}
									</p>
								</div>
								), 
									[module?.isLocked]
							  )
							})
						}
					</div>

				</div>
			</div>
			<div className="refrencelist br-10 border3 pt-3">
				<p className="p3 light_paragraptxt mb-2">REFERENCES:</p>
				<div
					className="refeneceancLink"
					dangerouslySetInnerHTML={{
						__html: refrence && refrence,
					}}>
				</div>
			</div>
		</>
	);
};
export default CourseAbout;
